<template>
  <div>
    <HeroSection />
    <AboutSection />
    <ShippingBannerSection />
    <ContactSection />
  </div>
</template>

<script>
import HeroSection from "../components/sections/hero/HeroSection.vue";
import AboutSection from "../components/sections/AboutSection.vue";
import ShippingBannerSection from "../components/sections/ShippingBannerSection.vue";
import ContactSection from "../components/sections/ContactSection.vue";

export default {
  components: {
    HeroSection,
    AboutSection,
    ShippingBannerSection,
    ContactSection,
  },
};
</script>
